import React, { useEffect } from "react";

const PageLoader = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="page-loader-wrapper">
      <span className="page-loader"></span>
    </div>
  );
};

export default PageLoader;
